ReactContentQuery.ExternalScripts.loadStories = {
    onPostRender: function (wpContext, handlebarsContext) {
        function maxItemByWidth() {
            var retorno = 1;
            if ($(window).width() >= 768) retorno = 2;
            if ($(window).width() >= 1200) retorno = 3;
            return retorno
        }
        SystemJS.import("/SiteAssets/js/melia.js").then(function (r) {
            SystemJS.import("components/menu").then(function (s) {
                new Swiper(".swiper-container.carrusel_display", {
                    slidesPerView: maxItemByWidth(),
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                    loop: !0,
                    loopFillGroupWithBlank: !0,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: !0
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    }
                });
                s.Menu.prototype.slider_success()
            })
        })
    }
};